import IcoMoon from '@/components/IcoMoon'
import InfoModal from '@/widgets/v2/AI/InfoModal'
import { useState } from 'react'

interface CheckBoxProps {
  text: string
}

const CheckBox = (props: CheckBoxProps): JSX.Element => {
  return (
    <div>
      <IcoMoon
        className="mr-xxxs"
        style={{ backgroundColor: '#52c400', color: 'white', borderRadius: '4px', marginTop: '-5px' }}
        color="white"
        icon="check"
        size={19}
      />
      <span>{props.text}</span>
    </div>
  )
}

const ComingSoon = (): JSX.Element => {
  const [showDialog, setShowDialog] = useState<boolean>(false)
  const handleDialogOpen = (): void => {
    setShowDialog(!showDialog)
  }

  return (
    <div className="flex flex-col gap-5 self-start text-left text-primary text-base">
      <h1 className="text-2xl font-extrabold leading-7 tracking-tighter tablet:text-4xl tablet:leading-[45px]">
        Helen is Coming Soon!
      </h1>
      <p>
        We're so excited to introduce Helen, your Digital Assistant powered guide to better living! While Helen isn't
        available to you just yet, we're working closely with our partners to bring it to you as soon as possible.{' '}
        <button className="font-bold underline text-secondary" onClick={handleDialogOpen}>
          Show me what else I can do with Digital Assistant
        </button>
      </p>
      <p>
        <span className="font-bold">Why Helen?</span>
        <br />
        Helen is designed to help older adults like you stay informed, connected, and confident in today's fast-changing
        world. Whether you need tips on staying safe online, finding health resources, or simply discovering new
        activities, Helen is here to assist you—safely and securely.
      </p>
      <p>
        <span className="font-bold">Your Safety Comes First</span>
        <br />
        We understand that technology should be easy to use and always put your privacy and security first. That's why
        we're carefully rolling out Helen in collaboration with our trusted partners, ensuring that it meets the highest
        safety standards before reaching our community.
      </p>
      <div>
        <p>
          <span className="font-bold">What You Can Expect</span>
          <br />
          Once available, Helen will help you:
        </p>
        <CheckBox text="Get answers to health and wellness questions" />
        <CheckBox text="Find classes, articles, and community groups tailored to your interests" />
        <CheckBox text="Learn how to protect yourself from scams and online risks" />
        <CheckBox text="Explore new ways to stay active, engaged, and independent" />
      </div>
      <p>
        We know you're eager to start using Helen, and we appreciate your patience. Stay tuned—Helen is on the way, and
        we can't wait to share it with you!
      </p>
      {showDialog && <InfoModal handleDialogOpen={handleDialogOpen} />}
    </div>
  )
}

export default ComingSoon
